import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

import "./CGV.css"
function CGV() {
  const [activeSection, setActiveSection] = useState("cgv");
  const [scrollProgress, setScrollProgress] = useState(0);

  // Handle scroll for progress bar
  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.body.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Toggle sections (CGV or CGU)
  const toggleSection = (section) => {
    setActiveSection(section);
  };

  // CGV items with improved wording
  const cgvItems = [
    {
      id: 'cgv-1',
      title: '📸 Notre Engagement',
      content: 'Bienvenue dans l\'univers Instaloc ! En réservant nos photobooths, vous acceptez ces conditions qui garantissent une expérience mémorable pour tous. Nous sommes là pour immortaliser vos moments de joie !'
    },
    {
      id: 'cgv-2',
      title: '💳 Réservation Simple',
      content: 'Réservez en quelques clics sur notre plateforme. Le règlement s\'effectue à la livraison ou à la remise du matériel. Consultez nos forfaits transparents sur notre page tarifs.'
    },
    {
      id: 'cgv-3',
      title: '🚚 Livraison & Setup',
      content: 'Optez pour notre service de livraison premium et détendez-vous ! Nos experts installeront tout le matériel pour vous, garantissant une mise en place parfaite. Un rendez-vous personnalisé sera programmé selon vos disponibilités.'
    },
    {
      id: 'cgv-4',
      title: '🔒 Caution & Sécurité',
      content: 'Une caution de 2000€ est demandée par chèque (non encaissé). Cette garantie nous permet de vous confier un équipement professionnel de haute qualité et sera restituée dès le retour du matériel en bon état.'
    },
    {
      id: 'cgv-5',
      title: '🤝 Respect du Matériel',
      content: 'Notre matériel est conçu pour résister à l\'ambiance de vos événements ! Nous vous demandons simplement d\'en prendre soin comme s\'il s\'agissait du vôtre. Chaque photobooth est vérifié avant et après chaque location.'
    },
    {
      id: 'cgv-6',
      title: '⚖️ Responsabilités Partagées',
      content: 'Vous êtes responsable du matériel pendant la durée de location. Nous vous garantissons un équipement parfaitement fonctionnel et vous accompagnons pour une utilisation optimale.'
    },
    {
      id: 'cgv-7',
      title: '❌ Résiliation',
      content: 'En cas de non-respect des conditions, nous pouvons être amenés à interrompre la prestation. Nous privilégions toujours le dialogue pour résoudre tout problème potentiel.'
    },
    {
      id: 'cgv-8',
      title: '💰 Politique de Remboursement',
      content: 'Votre satisfaction est notre priorité. Si le matériel présente un dysfonctionnement technique de notre responsabilité, nous vous proposerons un remplacement ou un remboursement adapté.'
    }
  ];

  // CGU items with improved wording
  const cguItems = [
    {
      id: 'cgu-1',
      title: '🌐 Votre Expérience Web',
      content: 'Notre site est conçu pour les utilisateurs majeurs. En naviguant sur Instaloc.fr, vous évoluez dans un espace créatif protégé par des droits d\'auteur, développé pour rendre votre expérience utilisateur exceptionnelle.'
    },
    {
      id: 'cgu-2',
      title: '✨ Création & Innovation',
      content: 'Chaque élément visuel et interactif de notre site reflète notre passion pour la photographie événementielle. Ces créations sont protégées et réservées à votre usage personnel, sans reproduction commerciale.'
    },
    {
      id: 'cgu-3',
      title: '🔐 Protection de Vos Données',
      content: 'Vos informations personnelles sont précieuses. Nous les traitons avec le plus grand soin, conformément au RGPD. Elles ne servent qu\'à améliorer votre expérience et ne seront jamais partagées sans votre consentement.'
    },
    {
      id: 'cgu-4',
      title: '👤 Utilisation Responsable',
      content: 'En rejoignant la communauté Instaloc, vous vous engagez à naviguer de manière éthique et respectueuse, créant ainsi un environnement positif pour tous nos utilisateurs.'
    },
    {
      id: 'cgu-5',
      title: '🔄 Évolution Continue',
      content: 'Notre service s\'améliore constamment. Les mises à jour des CGU reflètent cette évolution et sont publiées sur cette page pour vous tenir informé des nouveautés.'
    },
    {
      id: 'cgu-6',
      title: '🌩️ Imprévus & Solutions',
      content: 'Dans les rares cas où des circonstances exceptionnelles perturberaient nos services, nous mettons tout en œuvre pour rétablir rapidement la situation et vous tenir informé.'
    },
    {
      id: 'cgu-7',
      title: '🤗 La Communauté Instaloc',
      content: 'En utilisant nos services, vous rejoignez une communauté passionnée par la capture de moments uniques. Ces conditions nous permettent de garantir une expérience optimale pour chacun.'
    }
  ];

  return (
    <div className="legal-container">
      <Header />

      {/* Progress indicator */}
      <div className="progress-container">
        <div className="progress-bar" style={{ width: `${scrollProgress}%` }}></div>
      </div>

      <div className="legal-hero">
        <h1>Nos Conditions</h1>
        <p>Transparence et simplicité pour une expérience photo exceptionnelle</p>
      </div>

      <div className="section-toggle">
        <button 
          className={activeSection === "cgv" ? "active" : ""} 
          onClick={() => toggleSection("cgv")}
        >
          Conditions de Vente
        </button>
        <button 
          className={activeSection === "cgu" ? "active" : ""} 
          onClick={() => toggleSection("cgu")}
        >
          Conditions d'Utilisation
        </button>
      </div>

      <div className="legal-content">
        {activeSection === "cgv" && (
          <div className="card-container fade-in">
            <div className="section-intro">
              <h2>Conditions de Location de nos Photobooths</h2>
              <p>Pour que vos événements restent mémorables, dans les meilleures conditions.</p>
            </div>
            
            <div className="cards-grid">
              {cgvItems.map((item, index) => (
                <div 
                  key={item.id}
                  className="card-item slide-in"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div className="card-header">
                    <h3>{item.title}</h3>
                  </div>
                  <div className="card-content">
                    <p>{item.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeSection === "cgu" && (
          <div className="card-container fade-in">
            <div className="section-intro">
              <h2>Utilisation de notre Plateforme</h2>
              <p>Des règles simples pour une communauté responsable et créative.</p>
            </div>
            
            <div className="cards-grid">
              {cguItems.map((item, index) => (
                <div 
                  key={item.id}
                  className="card-item slide-in"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div className="card-header">
                    <h3>{item.title}</h3>
                  </div>
                  <div className="card-content">
                    <p>{item.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="legal-cta">
        <h2>Une question sur nos conditions ?</h2>
        <p>Notre équipe est disponible pour vous accompagner et clarifier tout point à l'e-mail suivant : contact@instaloc.fr</p>
        
      </div>

      <Footer />
    </div>
  );
}

export default CGV;